import CMSPage from "@/components/CMSPage";
import { Book } from "lucide-react";

export default function GuidesPage() {
  return (
    <CMSPage
      pageId="guides"
      defaultTitle="Homeowner Guides"
      defaultDescription="Expert guides covering everything you need to know about buying, selling, and moving home. From first-time buyers to experienced sellers, we have you covered."
      icon={Book}
    />
  );
}
